<template>
  <v-container fluid grid-list-lg mb-3>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3 pt-5>

        <h2 class="heading-2 align-left">Profile Image</h2>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert  :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
              <div v-if="picture" class="profile-image" >
                <div class="profile-image__avatar" :style="{backgroundImage: 'url(' + picture + ')'}" />

                <div class="profile-image__actions">
                  <button type="button" class="button" @click="deleteImage" >Delete</button>
                </div>
              </div>

              <div v-else-if="!picture && imageUrl" class="profile-image">
                <div class="profile-image__avatar" :style="{backgroundImage: 'url(' + imageUrl + ')'}" />

                <div class="profile-image__actions">
                  <button type="button" class="button" @click="saveImage" v-if="imageUrl">Upload</button>
                </div>
              </div>

              <div v-else class="profile-image" @click="pickFile" :v-model='imageName'>
								<div class="profile-image__avatar profile-image__avatar--empty">
									<svg  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24"><defs><path id="a" d="M15 9V.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V9H.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5H9v8.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V15h8.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5H15z"/></defs><use fill="#FFF" fill-rule="evenodd" xlink:href="#a"/></svg>
									<input
										type="file"
										style="display: none"
										ref="image"
										accept="image/*"
										@change="onFilePicked"
										>
                </div>

              </div>
            </v-flex>
          </template>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AWS from 'aws-sdk'
export default {
    name: 'UserProfileImage',
    data () {
        return {
            ready: false,
            valid: true,
            firstNameRules: [
                v => !!v || 'First name is required'
            ],
            lastNameRules: [
                v => !!v || 'Last name is required'
            ],
            usernameRules: [
                v => !!v || 'Email address is required',
                v => /.+@.+/.test(v) || 'Email must be valid',
                v => (!v.includes(' ')) || 'An email address can not contain any spaces'
            ],
            firstName: '',
            lastName: '',
            username: '',
            clubContact: false,
            partnerContact: false,
            error: null,
            success: null,
            loading: false,
            //
            files: null,
            fileDataUri: null,
            picture: null,
            sub: null,
            imageName: '',
            imageUrl: '',
            imageFile: '',
						acceptedMimeTypes: ['image/png', 'image/jpg', 'image/jpeg']
        }
    },
    created () {
        // load this user's latest information
        this.$getCurrentUserAttributes().subscribe((userData) => {
            this.username = userData.email
            this.firstName = userData.given_name
            this.lastName = userData.family_name
            this.picture = userData.picture
            this.sub = userData.sub
            this.clubContact = ((userData['custom:club_contact'] == "true" ) ? true : false )
            this.partnerContact = ((userData['custom:partner_contact'] == "true" ) ? true : false )
            // tell the app that we've finished loading
            this.ready = true
            console.log('userdata?', userData)

        }, 
        (err)=> {
            console.log('Unable to load user profile, session may not be present.')
        });

        this.$getSession().subscribe((result) => {
            if (result) {
                    
            var cognitoIdentityPoolkeyString = 'cognito-idp.' + process.env.VUE_APP_AWS_REGION + '.amazonaws.com/' + process.env.VUE_APP_AWS_IDENTITY_POOL
                        
            AWS.config.update({
                region: process.env.VUE_APP_AWS_REGION,
                credentials:AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID,
                    Logins: {
                        [cognitoIdentityPoolkeyString]: result.getIdToken().getJwtToken()
                    }
                })
            })

            AWS.config.credentials.get(function (err) {
                            if (err) console.log(err);
                            else console.log('CREDS',AWS.config.credentials);
                        });

            }
        })
        
    },
    methods: {
        pickFile () {
            this.$refs.image.click ()
        },
        onFilePicked (e) {
            this.files = e.target.files
            if(this.files[0] !== undefined) {
                this.imageName = this.files[0].name
                if(this.imageName.lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader ()
                fr.readAsDataURL(this.files[0])
                fr.addEventListener('load', () => {
                    this.imageUrl = fr.result
                    this.imageFile = this.files[0] // this is an image file that can be sent to server...
                })
            } else {
                this.imageName = ''
                this.imageFile = ''
                this.imageUrl = ''
            }
        },
        deleteImage (){
            this.error = null;
            this.success = null;

            var attributesList = {
                "picture": ""
            }
            // soft delete for now (keep archive in server)           
            this.$updateAttributes(attributesList).subscribe((response) => {
                console.log("update successful")
                this.success = {message: 'Profile image deleted'}
                this.picture = null
                this.imageUrl = null
                this.imageFile = null
            }, 
            (err)=> {
                console.log(err.message)
                this.error = err
            });  
        },
        validateFile(file) {
            console.log(file)
            return this.acceptedMimeTypes.includes(file.type) && file.size < 500000;
        },
        generateFileString() {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

            for (var i = 0; i < 12; i++)
                text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        },
        saveImage (){
            this.error = null;
            this.success = null;
           
            if(this.validateFile(this.files[0])){
                this.$getSession().subscribe((result) => {
                if (result) {
                       
                        /*var cognitoIdentityPoolkeyString = 'cognito-idp.' + process.env.VUE_APP_AWS_REGION + '.amazonaws.com/' + process.env.VUE_APP_AWS_IDENTITY_POOL
                        
                        AWS.config.update({
                            region: process.env.VUE_APP_AWS_REGION,
                            credentials:AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                                    IdentityPoolId: process.env.VUE_APP_AWS_IDENTITY_POOL_ID,
                                    Logins: {
                                    [cognitoIdentityPoolkeyString]: result.getIdToken().getJwtToken()
                                    }
                                })
                        })*/

                        AWS.config.credentials.get(function (err) {
                            if (err) console.log(err);
                            else console.log('CREDS',AWS.config.credentials);
                        });
                                                
                        var identityId = AWS.config.credentials.identityId;

                        var s3 = new AWS.S3({
                            apiVersion: '2006-03-01',
                            params: {Bucket: this.configValues.profilePictures.s3Bucket}
                            });
                        s3.headBucket(function(err, data) {
                        if (err) console.log('BUCKET'+err, err.stack); // an error occurred
                        else     console.log('BUCKET',data);           // successful response
                        });

                        if(!identityId){
                            this.error = {message: 'There was a temporary issue with uploading the image, please try again'}
                            console.log('image picture set error',this.error.message)
                        } else {

                            
                            
                            var file = this.files[0]
                            var mimePieces = file.type.split("/") 
                            var fileName = this.generateFileString() + '.' + mimePieces[mimePieces.length-1] //generate random filename and append filetype
                            var directory = identityId + '/'

                            var photoKey = directory + fileName
                            var vm = this
                            s3.upload({
                                Key: photoKey,
                                Body: file,
                                ACL: 'public-read'
                            }, function(err, data) {
                                if (err) {
                                    console.log('image upload error',err)
                                    vm.error = err
                                }else{
																		vm.success = {message: 'Image successfully uploaded'}
                                    var attributesList = {
                                        "picture": data.Location
                                    }
                                    vm.picture = data.Location
                                    vm.$updateAttributes(attributesList).subscribe((response) => {
                                        
																				console.log("update successful")
                                    
                                    }, 
                                    (err)=> {
                                        console.log('image picture set error',err.message)
                                    });  

                                }
                            })
                        }
                    }
                })
            }else{
                this.error = {message: "Image must be JPG or PNG and less than 500KB in size"}
            }
        }
    }
}
</script>

<style scoped lang="scss">
  .profile-image {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .profile-image__avatar {
    display: block;
    height: 90px;
    width: 90px;
    background-size: cover;
    border-radius: 50%;
		overflow: hidden;

		&--empty {
			background-color: grey;
			display: flex;

			svg {
				margin: auto;
			}
		}
		
		&--empty:hover {
			cursor: pointer;
		}
  }

  .profile-image__actions {
    margin: 0 0 0 40px;
    text-align: left;
  }
</style>